import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ce-gallery-pagination"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_swiper = _resolveComponent("swiper")!

  return (_openBlock(), _createBlock(_component_swiper, _mergeProps({ onSwiper: _ctx.setSwiper }, _ctx.swiperOptions, {
    onInit: _ctx.onSwiperInit,
    onSlideChange: _ctx.onSlideChange
  }), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default"),
      _renderSlot(_ctx.$slots, "navigation"),
      (_ctx.pagination)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 16, ["onSwiper", "onInit", "onSlideChange"]))
}